// This is a minimal bunyan compatible API to be used in the browser
// it's configured with the "browser" field in package.json

import * as Sentry from '@sentry/browser';

type Level = 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'fatal'

function logFunction (level: Level) {
  return (rec: any, msg = '', ...args: any[]) => {
    if (rec.err) {
      if (rec.err instanceof Error) {
        Sentry.captureException(rec.err);
      } else {
        Sentry.captureException(new Error('Invalid Error object'));
      }
    }
    const logMethod = ['error', 'fatal'].includes(level) ? 'error' : 'log';
    console[logMethod]('%s [%s]: %s %o', level, new Date().toISOString(), msg, rec);
  };
}

function createLogger (fields: any = {}) {
  const logger = {
    trace: logFunction('trace'),
    debug: logFunction('debug'),
    info: logFunction('info'),
    warn: logFunction('warn'),
    error: logFunction('error'),
    fatal: logFunction('fatal'),
    child: (extraFields: any) => createLogger({ ...fields, ...extraFields })
  };
  return logger;
}

export default createLogger();
